import { ElementDetails } from "@/lib/types";
import { HackernewsProps } from "./types";

export const details = {
  name: "Hackernews",
  description: "Hackernews top stories",
  tags: ["News"],
  category: "Hackernews",
  grid: {
    "3x1": [3, 1],
    "3x2": [3, 2],
    "3x3": [3, 3],
    "4x1": [4, 1],
    "4x2": [4, 2],
    "4x4": [4, 4],
  },
  defaultProps: {},
} as ElementDetails<HackernewsProps>;
